import { render, staticRenderFns } from "./NoteTypeList.vue?vue&type=template&id=4a761bd3&"
import script from "./NoteTypeList.vue?vue&type=script&lang=js&"
export * from "./NoteTypeList.vue?vue&type=script&lang=js&"
import style0 from "./NoteTypeList.vue?vue&type=style&index=0&id=4a761bd3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports